module.exports = __webpack_public_path__ + "static/img/cont62 (2).6ec1755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont62 (2).jpg
// module id = RQ68
// module chunks = 0